import LegalPage from './LegalPage';

const DPA = () => {
  return <LegalPage file="dpa" title="Auftragsverarbeitungsvertrag (DPA)" />;
};

export default DPA;
